jQuery(function($)
{
    var
        $reloadTrigger = $('.reload');

    $($reloadTrigger).click(function()
    {
        window.location.reload();
        return false;
    });
});
